import { getCreateWishListUrlMagento } from "../../../common/constants/shop-api";
import { getResponseData } from "../../../common/utils/api-utils";
import { getAuthenticationHeaders } from "../../../common/utils/auth-utils";
import { CreateWishListRequest } from "../interfaces/wish-list-actions.interface";

export async function createWishListApiCallMagento(requestBody: CreateWishListRequest) {
  const url = getCreateWishListUrlMagento();
  return await getResponseData(
    new Request(url, {
      method: 'POST',
      credentials: 'include',
      headers: getAuthenticationHeaders(),
      body: JSON.stringify(requestBody)
  }));
}